import React, { createContext, useContext } from 'react'
import { IWidget } from '@dash.bar/types'
import { Themes } from '@webstollen/react-native/lib/types/theme'
import { IIntervals } from './Intervals'

export interface IWidgetDefinition {
  component: React.ReactNode
  title?: string
  minVersion: string
  settings?: {
    autoRefresh?: boolean
    refreshInterval?: number
    rowsPerPage?: number
    interval?: IIntervals
  }
  icon?: Record<Themes, string>
  authorization?: string
}

// TODO: Move File to => context/

type ModifyWidgetContextT = {
  editWidget: (widget: IWidget) => void
  deleteWidget: (widget: IWidget) => void
  updateWidget: (widget: IWidget) => void
  createWidget: (widget: IWidget) => void
}

export const ModifyWidgetContext = createContext<ModifyWidgetContextT>({
  editWidget: () => null,
  deleteWidget: () => null,
  updateWidget: () => null,
  createWidget: () => null,
})

export const useModifyWidgetContext = () => useContext<ModifyWidgetContextT>(ModifyWidgetContext)

type UpdateWidgetContextT = (widget: IWidget) => void

export const UpdateWidgetContext = createContext<UpdateWidgetContextT>(() => null)

export const useUpdateWidgetContext = () => useContext<UpdateWidgetContextT>(UpdateWidgetContext)
